import { Todo } from "@/shared/domain";

import { getSpApi } from "./apiRoot";
import { UrlManager } from "./UrlManager";

// Swagger: https://ibpcsrcdev01.portima.net/mybrokerapi/swagger/index.html

/**
 * Returns all todo's
 */
export const getToDos = async (): Promise<Todo[]> => {
    const { data } = await getSpApi().get<MyBrokerApi.ToDoPayload>(UrlManager.toDo());
    return data.result;
};
